








































































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";

import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";

interface PortalJobsearchUsefulWpConfig {
  wp_base_url?: string;
  wp_category_ids?: string[];
  wp_category_since?: string;
  wp_category_days?: number;
}

interface WpCategory {
  id: number;
  name: string;
}

interface StringItem {
  text: string;
  value: string;
}

@Component({
  components: {
    AppTextField,
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  /** 初回ロード完了フラグ */
  private initLoadingDone = false;
  private config: PortalJobsearchUsefulWpConfig = {};
  private categoryItems: StringItem[] = [];

  public async created() {
    await this.fetchItem();
    this.initLoadingDone = true;
  }

  /** 情報取得 */
  private async fetchItem() {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_useful_wp_config/get",
      {},
      async (res) => {
        this.config = res.data.config || {};
        await this.fetchCategoryItems();
      }
    );
  }

  private async fetchCategoryItems() {
    if (this.config.wp_base_url) {
      const url = (
        this.config.wp_base_url + "/categories?per_page=100&parent=1"
      ).replaceAll("//categories", "/categories");
      try {
        const res = await fetch(url);
        if (res.ok) {
          const data = await res.json();
          data.forEach((category: WpCategory) => {
            this.categoryItems.push({
              text: category.name,
              value: String(category.id),
            });
          });
        } else {
          await this.$openAlert(
            `${url} のアクセスで HTTP Error ${res.status} が発生しました`
          );
        }
      } catch (e) {
        await this.$openAlert(`${url} のアクセスでエラーが発生しました ${e}`);
      }
    }
  }

  private addCategoryId(categoryId: string) {
    this.config.wp_category_ids?.push(categoryId);
  }

  private removeCategoryId(index: number) {
    if (
      this.config.wp_category_ids &&
      index < this.config.wp_category_ids.length
    ) {
      this.config.wp_category_ids.splice(index, 1);
    }
  }

  private async save() {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_useful_wp_config/save",
      {
        config: this.config,
      },
      () => {
        this.$openAlert("保存に成功しました");
      }
    );
  }
}
